module.exports = __webpack_public_path__ + "images/17ff85c0b187cdbae0ce38bcd0058313.svg";